import { DownloadOutlined as DownloadOutlinedIcon } from '@mui/icons-material'
import Table from '../../ui/Table'
import PaymentStatusChip from './PaymentStatusChip'

const PaymentHistoryTable = ({ invoices = [], onAction, loading = false, error = '' }) => {
  const columns = [
    { id: 'chargeDate', label: 'Data da cobrança', width: '32%', render: (invoice) => invoice.chargeDate },
    { id: 'total', label: 'Valor total', width: '18%', render: (invoice) => invoice.total, align: 'right' },
    { id: 'status', label: 'Status', width: '16%', render: (invoice) => <PaymentStatusChip status={invoice.status} label={invoice.statusLabel} /> },
    {
      id: 'actions',
      label: '',
      width: '25%',
      align: 'right',
      render: (invoice) => (
        <button
          type="button"
          className="scout-settings-pill-button scout-settings-pill-button--outline"
          onClick={() => onAction?.(invoice.action)}
          disabled={!invoice.action?.url}
        >
          <span>{invoice.actionLabel}</span>
          <DownloadOutlinedIcon />
        </button>
      ),
    },
  ]

  return (
    <Table
      columns={columns}
      data={invoices}
      rowKey={(invoice) => invoice.id}
      loading={loading}
      error={error}
      emptyMessage="Nenhuma cobrança encontrada para esta empresa."
      className="scout-settings-card--table"
      tableClassName="scout-table"
    />
  )
}

export default PaymentHistoryTable
